import { ALL_BU, ALL_STORE } from "constants/DashboardContanst";
import { errorMessage } from "helpers/utils";
import jwt_decode from "jwt-decode";
import {
  TYPE_INVOICE,
  TYPE_REPORT,
  TYPE_TAX_DEDUCT,
} from "pages/ReportInvoiceError/helper/functionHelper";
import { call, put, select, takeEvery } from "redux-saga/effects";
import SummaryInvoiceDataService from "services/SummaryInvoiceDataService";
import { AUTH_TOKEN } from "store/auth/login/actionTypes";
import {
  CREATE_INVOICE_CYCLES,
  CREATE_REPORT_INVOICE,
  DOWNLOAD_REPORT_INVOICE,
  EXECUTE_REPORT,
  EXECUTE_TAX_DEDUCT_REPORT,
  GET_REPORT_INVOICE_PROGRESS,
  LIST_INVOICE_TO_SUMMARY,
  LIST_KHDD_INVOICE_TO_SUMMARY,
  RELEASE_INVOICE_CYCLES,
  REPORT_INVOICE_LIST,
  SUMMARY_INVOICE_LIST,
  TRANSFER_USB_INVOICE_CYCLES,
} from "./actionTypes";
import {
  createInvoiceCyclesFail,
  createInvoiceCyclesSuccess,
  createReportInvoiceFail,
  createReportInvoiceSuccess,
  downloadReportInvoiceFail,
  downloadReportInvoiceSuccess,
  executeReportFail,
  executeReportSuccess,
  executeTaxDeductReportFail,
  executeTaxDeductReportSuccess,
  getReportInvoiceListFail,
  getReportInvoiceListSuccess,
  getReportInvoiceProgress,
  getReportInvoiceProgressFail,
  getReportInvoiceProgressSuccess,
  getSummaryInvoiceListFail,
  getSummaryInvoiceListSuccess,
  listInvoiceToSummaryFail,
  listInvoiceToSummarySuccess,
  listKhddInvoiceToSummaryFail,
  listKhddInvoiceToSummarySuccess,
  releaseInvoiceCyclesFail,
  releaseInvoiceCyclesSuccess,
  transferUsbInvoiceCyclesFail,
  transferUsbInvoiceCyclesSuccess,
} from "./actions";

function* fetchListSummaryInvoiceList({ params }) {
  try {
    // console.log("fetchGetListUpload");
    // console.log("params", params);
    // Param
    const perPage = params.sizePerPage;
    const page = params.page;
    const columnFilter = params.columnFilter;
    const keywords = params.keywords;
    const sort = params.sort;
    // Call api
    const response = yield call(
      SummaryInvoiceDataService.listInvoiceCycles,
      page,
      perPage,
      columnFilter,
      keywords,
      sort
    );
    const totalCount = response._meta.totalCount;
    // console.log("response", response);
    yield put(getSummaryInvoiceListSuccess(response.items, totalCount));
  } catch (error) {
    yield put(getSummaryInvoiceListFail(errorMessage(error)));
  }
}

function* fetchReportInvoiceList({ params, typeReport }) {
  try {
    // console.log("fetchGetListUpload");
    // console.log("params", params);
    // Param
    const perPage = params.sizePerPage;
    const page = params.page;
    let columnFilter = params.columnFilter;
    const keywords = params.keywords;
    const sort = params.sort;
    let response = null;
    // Call api
    let { buTenantHeader, buStoreHeader, listBuOfTenant, buTenantHeaderInfo } =
      yield select(state => state.Dashboard);
    const listBuParentCode = listBuOfTenant
      .filter(item => item.id)
      .map(item => item.code);

    let bu_parent = undefined;
    let bu_code = undefined;
    if (buStoreHeader === ALL_STORE) {
      bu_parent = buTenantHeaderInfo.id;
    } else if (buStoreHeader === ALL_BU) {
      bu_parent = listBuOfTenant
        .filter(item => item.id)
        .map(item => item.id)
        .join(",");
    } else {
      bu_code = buStoreHeader;
    }
    if (typeReport === TYPE_REPORT.ERROR) {
      columnFilter = {
        ...columnFilter,
        "filter[type]": 10,
        "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
        bu_parent,
      };
      response = yield call(
        SummaryInvoiceDataService.listReportInvoice,
        page,
        perPage,
        columnFilter,
        keywords,
        sort
      );
    } else if (typeReport === TYPE_INVOICE.REPLACE) {
      columnFilter = {
        ...columnFilter,
        "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
        bu_parent,
        "filter[record_status]": "O",
      };
      response = yield call(
        SummaryInvoiceDataService.listInvoiceReplace,
        page,
        perPage,
        columnFilter,
        keywords,
        sort
      );
    } else if (typeReport === TYPE_INVOICE.ADJUST) {
      columnFilter = {
        ...columnFilter,
        "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
        bu_parent,
        "filter[record_status]": "O",
      };
      response = yield call(
        SummaryInvoiceDataService.listInvoiceAdjust,
        page,
        perPage,
        columnFilter,
        keywords,
        sort
      );
    } else if (typeReport === TYPE_REPORT.INVOICE) {
      columnFilter = {
        ...columnFilter,
        "filter[type]": 40,
        "filter[is_pos]": 0,
        invoice_report_type: typeReport,
      };
      response = yield call(
        SummaryInvoiceDataService.listReportInvoice,
        page,
        perPage,
        columnFilter,
        keywords,
        sort
      );
    } else if (typeReport === TYPE_REPORT.INVOICE_POS) {
      columnFilter = {
        ...columnFilter,
        "filter[type]": 40,
        "filter[is_pos]": 1,
        invoice_report_type: typeReport,
      };
      response = yield call(
        SummaryInvoiceDataService.listReportInvoice,
        page,
        perPage,
        columnFilter,
        keywords,
        sort
      );
    } else if (typeReport === TYPE_REPORT.INVOICE_WAREHOUSES) {
      columnFilter = {
        ...columnFilter,
        "filter[type]": 40,
        invoice_report_type: typeReport,
      };
      response = yield call(
        SummaryInvoiceDataService.listReportInvoice,
        page,
        perPage,
        columnFilter,
        keywords,
        sort
      );
    } else if (typeReport === TYPE_REPORT.INVOICE_WAREHOUSES_AGENCY) {
      columnFilter = {
        ...columnFilter,
        "filter[type]": 40,
        invoice_report_type: typeReport,
      };
      response = yield call(
        SummaryInvoiceDataService.listReportInvoice,
        page,
        perPage,
        columnFilter,
        keywords,
        sort
      );
    } else if (typeReport === TYPE_REPORT.TRANSFER) {
      columnFilter = {
        ...columnFilter,
        "filter[type]": 50,
      };
      response = yield call(
        SummaryInvoiceDataService.listReportInvoice,
        page,
        perPage,
        columnFilter,
        keywords,
        sort
      );
    } else if (typeReport === TYPE_TAX_DEDUCT.REPLACE) {
      columnFilter = {
        ...columnFilter,
        "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
        bu_parent,
      };
      response = yield call(
        SummaryInvoiceDataService.listTaxDeductReplace,
        page,
        perPage,
        columnFilter,
        keywords,
        sort
      );
    } else if (typeReport === TYPE_TAX_DEDUCT.ADJUST) {
      columnFilter = {
        ...columnFilter,
        "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
        bu_parent,
      };
      response = yield call(
        SummaryInvoiceDataService.listTaxDeductAdjust,
        page,
        perPage,
        columnFilter,
        keywords,
        sort
      );
    } else if (typeReport === TYPE_REPORT.TAX_DEDUCT) {
      columnFilter = {
        ...columnFilter,
        "filter[type]": 1,
      };
      response = yield call(
        SummaryInvoiceDataService.listTaxDeductReport,
        page,
        perPage,
        columnFilter,
        keywords,
        sort,
        bu_code,
        bu_parent
      );
    } else if (typeReport === TYPE_REPORT.TAX_DEDUCT_EXPORT) {
      columnFilter = {
        ...columnFilter,
        "filter[type]": 40,
      };
      response = yield call(
        SummaryInvoiceDataService.listTaxDeductReport,
        page,
        perPage,
        columnFilter,
        keywords,
        sort
        // bu_code,
        // bu_parent
      );
    } else if (
      typeReport === TYPE_REPORT.TAX_DEDUCT_REPORT_TCT ||
      typeReport === TYPE_REPORT.TAX_DEDUCT_USE ||
      typeReport === TYPE_REPORT.TAX_DEDUCT_TRANSFER
    ) {
      let typFinal = null;
      switch (typeReport) {
        case TYPE_REPORT.TAX_DEDUCT_REPORT_TCT:
          typFinal = 2;
          break;
        case TYPE_REPORT.TAX_DEDUCT_USE:
          typFinal = 3;
          break;
        case TYPE_REPORT.TAX_DEDUCT_TRANSFER:
          typFinal = 5;
          break;
        default:
          break;
      }
      columnFilter = {
        ...columnFilter,
        "filter[bu_code]": buStoreHeader,
        "filter[type]": typFinal,
      };
      response = yield call(
        SummaryInvoiceDataService.listTaxDeductReport,
        page,
        perPage,
        columnFilter,
        keywords,
        sort
      );
    } else {
      const info = localStorage.getItem(AUTH_TOKEN)
        ? jwt_decode(localStorage.getItem(AUTH_TOKEN))
        : null;
      const makerId = info?.["userInfo"]?.userCode;
      columnFilter = {
        ...columnFilter,
        "filter[bu_code]": bu_code !== ALL_BU ? bu_code : undefined,
        bu_parent,
        "filter[type]": typeReport,
        "filter[maker_id]": makerId,
      };

      //   if (!columnFilter["filter[type]"]) {
      //   columnFilter = {
      //     ...columnFilter,
      //     "filter[type][in]": typeReport,
      //   };
      //   }
      response = yield call(
        SummaryInvoiceDataService.listReportInvoice,
        page,
        perPage,
        columnFilter,
        keywords,
        sort
      );
    }

    const totalCount = response._meta.totalCount;
    // console.log("response", response);
    yield put(getReportInvoiceListSuccess(response.items, totalCount));
  } catch (error) {
    yield put(getReportInvoiceListFail(errorMessage(error)));
  }
}

function* fetchReleaseInvoiceCycles({ id }) {
  try {
    const response = yield call(
      SummaryInvoiceDataService.releaseInvoiceCycles,
      id
    );
    if (response.result) {
      // Wait
      yield sleep(1);
      yield put(releaseInvoiceCyclesSuccess());
    } else {
      yield put(
        releaseInvoiceCyclesFail("Gửi phát hành bảng tổng hợp dữ liệu thất bại")
      );
    }
  } catch (error) {
    yield put(releaseInvoiceCyclesFail(errorMessage(error)));
  }
}

function* fetchListInvoiceToSummary({ params, khmshdon }) {
  try {
    const response = yield call(
      SummaryInvoiceDataService.searchInvoice,
      params,
      khmshdon
    );
    if (response.result) {
      response.items = response.items.map(item => {
        return {
          ...item,
          sTbao: "",
          dateTbao: "",
          noteTbao: "",
          newStatus: "Giữ nguyên",
        };
      });
      yield put(listInvoiceToSummarySuccess(response.items));
    } else {
      yield put(listInvoiceToSummaryFail("fetchListInvoiceToSummary Fail"));
    }
  } catch (error) {
    yield put(listInvoiceToSummaryFail(errorMessage(error)));
  }
}

function* fetchListKHDDInvoiceToSummary({ id }) {
  try {
    const response = yield call(SummaryInvoiceDataService.searchKHDD, id);
    if (response.result) {
      yield put(listKhddInvoiceToSummarySuccess(response.items));
    } else {
      yield put(
        listKhddInvoiceToSummaryFail("fetchListKHDDInvoiceToSummary Fail")
      );
    }
  } catch (error) {
    yield put(listKhddInvoiceToSummaryFail(errorMessage(error)));
  }
}

function* fetchCreateInvoiceCycles({ data }) {
  try {
    const response = yield call(
      SummaryInvoiceDataService.createInvoiceCycles,
      data
    );
    if (response) {
      yield put(createInvoiceCyclesSuccess());
    } else {
      yield put(createInvoiceCyclesFail("Tạo bảng tổng hợp dữ liệu thất bại"));
    }
  } catch (error) {
    yield put(createInvoiceCyclesFail(errorMessage(error)));
  }
}

function* fetchCreateReportInvoice({ data, typeReport }) {
  try {
    let response = null;
    let { buTenantHeader, buStoreHeader } = yield select(
      state => state.Dashboard
    );
    if (typeReport === TYPE_REPORT.ERROR) {
      response = yield call(
        SummaryInvoiceDataService.createReportInvoiceError,
        data,
        buTenantHeader
      );
    } else if (typeReport === TYPE_REPORT.TAX_DEDUCT_USE) {
      response = yield call(
        SummaryInvoiceDataService.createReportTaxDeductUse,
        data
      );
    } else if (typeReport === TYPE_REPORT.TAX_DEDUCT_TRANSFER) {
      response = yield call(
        SummaryInvoiceDataService.createReportTaxDeductTransfer,
        data
      );
    } else {
      response = yield call(
        SummaryInvoiceDataService.createReportInvoice,
        data,
        typeReport
      );
    }
    if (response && response.id) {
      yield put(getReportInvoiceProgress(response.id, false, typeReport));
      yield put(createReportInvoiceSuccess());
    } else {
      yield put(createReportInvoiceFail("Tạo bảng kê hóa đơn thất bại"));
    }
  } catch (error) {
    yield put(createReportInvoiceFail(errorMessage(error)));
  }
}

function* fetchGetReportInvoiceProgress({ id, typeReport }) {
  try {
    let response = null;
    if (
      typeReport === TYPE_REPORT.TAX_DEDUCT ||
      typeReport === TYPE_REPORT.TAX_DEDUCT_EXPORT ||
      typeReport === TYPE_REPORT.TAX_DEDUCT_REPORT_TCT ||
      typeReport === TYPE_REPORT.TAX_DEDUCT_USE ||
      typeReport === TYPE_REPORT.TAX_DEDUCT_TRANSFER
    ) {
      response = yield call(
        SummaryInvoiceDataService.progressTaxDeductReportInvoice,
        id
      );
    } else {
      response = yield call(
        SummaryInvoiceDataService.progressReportInvoice,
        id
      );
    }
    if (response && response.result) {
      let { reportInvoiceProgress } = yield select(
        state => state.summaryInvoiceData
      );
      if (response.percent !== 100 && reportInvoiceProgress.isStart) {
        yield sleep(1);
        yield put(getReportInvoiceProgress(id, false, typeReport));
      }
      yield put(
        getReportInvoiceProgressSuccess(response.percent, response.status)
      );
    } else {
      yield put(
        getReportInvoiceProgressFail("Tiến trình bảng kê hóa đơn thất bại")
      );
    }
  } catch (error) {
    yield put(getReportInvoiceProgressFail(errorMessage(error)));
  }
}

function sleep(sec) {
  return new Promise(resolve => setTimeout(resolve, sec * 1000));
}

function* fetchTransferUsb({ id, typeSend, content }) {
  try {
    const data = {
      id,
      type: typeSend,
      content,
    };
    const response = yield call(SummaryInvoiceDataService.transfer, data);
    if (response.result) {
      yield sleep(1);
      yield put(transferUsbInvoiceCyclesSuccess());
    } else {
      yield put(transferUsbInvoiceCyclesFail(response?.error?.content));
    }
  } catch (error) {
    yield put(transferUsbInvoiceCyclesFail(errorMessage(error)));
  }
}

function* fetchDownloadReport({
  resource_id,
  fileDownloadName,
  responseType = "blob",
  pathType = ".xlsx",
  typeReport,
}) {
  try {
    console.log("🚀 ~ fetchDownloadReport ", { typeReport });
    let response = null;
    if (
      typeReport === TYPE_REPORT.TAX_DEDUCT ||
      typeReport === TYPE_REPORT.TAX_DEDUCT_REPORT_TCT ||
      typeReport === TYPE_REPORT.TAX_DEDUCT_USE ||
      typeReport === TYPE_REPORT.TAX_DEDUCT_TRANSFER ||
      typeReport === TYPE_REPORT.TAX_DEDUCT_EXPORT
    ) {
      response = yield call(
        SummaryInvoiceDataService.downloadTaxDeductReport,
        resource_id,
        responseType
      );
    } else {
      response = yield call(
        SummaryInvoiceDataService.downloadReport,
        resource_id,
        responseType
      );
    }
    if (
      response.size > 0 &&
      response.size !== undefined &&
      response.size !== null
    ) {
      const file = URL.createObjectURL(response);
      yield put(
        downloadReportInvoiceSuccess(null, file, fileDownloadName + pathType)
      );
    } else {
      yield put(downloadReportInvoiceFail("Download file thất bại"));
    }
  } catch (error) {
    yield put(downloadReportInvoiceFail("Download file thất bại"));
  }
}

function* fetchExecuteReport({ id }) {
  try {
    const response = yield call(SummaryInvoiceDataService.executeReport, id);
    if (response.result) {
      yield put(executeReportSuccess());
    } else {
      yield put(executeReportFail(response?.error?.content));
    }
  } catch (error) {
    yield put(executeReportFail(errorMessage(error)));
  }
}

function* fetchExecuteTaxDeductReport({ id }) {
  try {
    const response = yield call(
      SummaryInvoiceDataService.executeTaxDeductReport,
      id
    );
    if (response.result) {
      yield put(executeTaxDeductReportSuccess());
    } else {
      yield put(executeTaxDeductReportFail(response?.error?.content));
    }
  } catch (error) {
    yield put(executeTaxDeductReportFail(errorMessage(error)));
  }
}

function* summaryInvoiceDataSaga() {
  yield takeEvery(SUMMARY_INVOICE_LIST, fetchListSummaryInvoiceList);
  yield takeEvery(REPORT_INVOICE_LIST, fetchReportInvoiceList);
  yield takeEvery(RELEASE_INVOICE_CYCLES, fetchReleaseInvoiceCycles);
  yield takeEvery(CREATE_INVOICE_CYCLES, fetchCreateInvoiceCycles);
  yield takeEvery(CREATE_REPORT_INVOICE, fetchCreateReportInvoice);
  yield takeEvery(GET_REPORT_INVOICE_PROGRESS, fetchGetReportInvoiceProgress);
  yield takeEvery(LIST_INVOICE_TO_SUMMARY, fetchListInvoiceToSummary);
  yield takeEvery(LIST_KHDD_INVOICE_TO_SUMMARY, fetchListKHDDInvoiceToSummary);
  yield takeEvery(TRANSFER_USB_INVOICE_CYCLES, fetchTransferUsb);
  yield takeEvery(DOWNLOAD_REPORT_INVOICE, fetchDownloadReport);
  yield takeEvery(EXECUTE_REPORT, fetchExecuteReport);
  yield takeEvery(EXECUTE_TAX_DEDUCT_REPORT, fetchExecuteTaxDeductReport);
}

export default summaryInvoiceDataSaga;
